export const GET_ORGANIZATION_REQUEST = 'GET_ORGANIZATION_REQUEST';
export const GET_ORGANIZATION_SUCCESS = 'GET_ORGANIZATION_SUCCESS';
export const GET_ORGANIZATION_FAILED = 'GET_ORGANIZATION_FAILED';

export const UPDATE_ORGANIZATION_REQUEST = 'UPDATE_ORGANIZATION_REQUEST';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAILED = 'UPDATE_ORGANIZATION_FAILED';

export const GENERATE_API_TOKEN_REQUEST = 'GENERATE_API_TOKEN_REQUEST';
export const GENERATE_API_TOKEN_SUCCESS = 'GENERATE_API_TOKEN_SUCCESS';
export const GENERATE_API_TOKEN_FAILED = 'GENERATE_API_TOKEN_FAILED';

export const GENERATE_QC_TOKEN_REQUEST = 'GENERATE_QC_TOKEN_REQUEST';
export const GENERATE_QC_TOKEN_SUCCESS = 'GENERATE_QC_TOKEN_SUCCESS';
export const GENERATE_QC_TOKEN_FAILED = 'GENERATE_QC_TOKEN_FAILED';

export const GENERATE_REPORTS_API_TOKEN_REQUEST = 'GENERATE_REPORTS_API_TOKEN_REQUEST';
export const GENERATE_REPORTS_API_TOKEN_SUCCESS = 'GENERATE_REPORTS_API_TOKEN_SUCCESS';
export const GENERATE_REPORTS_API_TOKEN_FAILED = 'GENERATE_REPORTS_API_TOKEN_FAILED';
